import { render } from "./JobOffers.vue?vue&type=template&id=40dca565&scoped=true"
import script from "./JobOffers.vue?vue&type=script&lang=js"
export * from "./JobOffers.vue?vue&type=script&lang=js"

import "./JobOffers.vue?vue&type=style&index=0&id=40dca565&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\PLATEFORME-AUTO-PREFEREPLUS\\paprep-spa\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dca565"]])

export default __exports__